// Import model
import { DataviewProjectNoteResponse } from '../models/DataviewProjectNoteResponse';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { DataView } from '../models/DataView';
import { FilterProjectNoteRequest } from '../models/FilterProjectNoteRequest';
import { ProjectNote } from '../models/ProjectNote';

// Import dependency serializers (for complex types)
import { DataViewSerializer } from './DataViewSerializer';
import { FilterProjectNoteRequestSerializer } from './FilterProjectNoteRequestSerializer';
import { ProjectNoteSerializer } from './ProjectNoteSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for DataviewProjectNoteResponse - handles JSON serialization and deserialization with type validation
 */
export class DataviewProjectNoteResponseSerializer {
  /**
   * Deserializes a JSON string into a DataviewProjectNoteResponse instance
   */
  static deserialize(json: string): DataviewProjectNoteResponse {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a DataviewProjectNoteResponse instance
   */
  static fromObject(obj: any): DataviewProjectNoteResponse {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to DataviewProjectNoteResponse');
    }


    const instance: DataviewProjectNoteResponse = {
      result: obj['Result'] ? (obj['Result'] as any[]).map((item: any) =>
        ProjectNoteSerializer.fromObject(item)
      ) : [] as any,
      request: obj['Request'] ? FilterProjectNoteRequestSerializer.fromObject(obj['Request']) : undefined as any,
      dataView: obj['DataView'] ? DataViewSerializer.fromObject(obj['DataView']) : undefined as any,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of DataviewProjectNoteResponse instances
   */
  static deserializeArray(json: string): DataviewProjectNoteResponse[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a DataviewProjectNoteResponse instance to a JSON string
   */
  static serialize(instance: DataviewProjectNoteResponse): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a DataviewProjectNoteResponse instance to a plain object
   */
  static toObject(instance: DataviewProjectNoteResponse): any {
    return {
      'Result': instance.result?.map((item: any) =>
        ProjectNoteSerializer.toObject(item)
      ),
      'Request': instance.request ? FilterProjectNoteRequestSerializer.toObject(instance.request) : undefined,
      'DataView': instance.dataView ? DataViewSerializer.toObject(instance.dataView) : undefined,
    };
  }

  /**
   * Serializes an array of DataviewProjectNoteResponse instances to a JSON string
   */
  static serializeArray(instances: DataviewProjectNoteResponse[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
